import CarouselSlide from '../components/CarouselSlide';
import MBrandBar from '../components/MBrandBar';
import MCarousel from '../components/MCarousel';
import MFooter from '../components/MFooter';
import MGetInvolved from '../components/MGetInvolved';
import MHeader from '../components/MHeader';
import MIntro from '../components/MIntro';
import MLatestNews from '../components/MLatestNews';
import MListCards from '../components/MListCards';
import MListNav from '../components/MListNav';
import MProgramMapAd from '../components/MProgramMapAd';
import MProjectsCurrent from '../components/MProjectsCurrent';
import MapParent from '../components/MapParent';
import PageContent from '../components/PageContent';
import PageContentLanding from '../components/PageContentLanding';
import PageEventDetails from '../components/PageEventDetails';
import PageEvents from '../components/PageEvents';
import PageGetInvolved from '../components/PageGetInvolved';
import PageHome from '../components/PageHome';
import PageProjects from '../components/PageProjects';
import Tag from '../components/Tag';
import PageNews from '../components/PageNews';

import strapi5Populate from './strapi5-populate.json';


//export const CMS_PATH = "https://ladot-staging-cms.getsomeglue.com";
// export const CMS_PATH = 'https://ladot-dev-cms.getsomeglue.com';
// export const CMS_PATH = 'http://192.168.43.215:1337'; //chris venus e4
// Strapi base URL for deployed builds — set CMS_URL at build time (CI / Azure Static Web Apps).
// See vite.config.js `define` and production build guard. No hardcoded fallback (wrong host / CORS).
const CMS_URL_MISSING_MSG =
  'CMS_URL is not configured. Set CMS_URL when building for deploy (e.g. Azure SWA pipeline env). ' +
  'Local Vite dev on port 3000–3998 uses the same host on :1337 automatically.';

function buildTimeCmsUrl() {
  // Vite `define` replaces process.env.CMS_URL with a string literal at build time.
  // No `typeof process` guard — that expression isn't substituted, and `process` is undefined in the browser.
  const url = process.env.CMS_URL;
  return url ? String(url).trim().replace(/\/+$/, '') : '';
}

function buildTimeCmsUploadUrl() {
  const url = process.env.CMS_UPLOAD_URL;
  return url ? String(url).trim().replace(/\/+$/, '') : '';
}

// Vite dev server (`npm run dev`): default site port is 3000. For local dev on localhost/LAN
// with the app on an even port in 3000–3998, point Strapi at the same host on 1337
// (exclude 4000 — `open:dist` / `preview` use that for production-build preview vs real CMS).
function isLocalWebpackDevelHost(hostname) {
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]') return true;
  return /^192\.168\.|^10\.|^172\.(1[6-9]|2[0-9]|3[01])\./.test(hostname);
}

function cmsPathForBrowser() {
  if (typeof window !== 'undefined' && window.location) {
    const { hostname, port, protocol } = window.location;
    const p = parseInt(port, 10);
    if (isLocalWebpackDevelHost(hostname) && !Number.isNaN(p) && p >= 3000 && p < 4000) {
      return `${protocol}//${hostname}:1337`;
    }
  }
  const cms = buildTimeCmsUrl();
  if (cms) {
    return cms;
  }
  if (typeof window !== 'undefined') {
    console.error(CMS_URL_MISSING_MSG);
  }
  throw new Error(CMS_URL_MISSING_MSG);
}

/** Current Strapi base URL (call per fetch — do not cache; BrowserSync port / HMR can change). */
export function getCmsPath() {
  return cmsPathForBrowser();
}

/** Base URL for /uploads assets and [cms] in rich text (blob storage when CMS_UPLOAD_URL is set). */
export function getCmsUploadBase() {
  const upload = buildTimeCmsUploadUrl();
  if (upload) {
    return upload;
  }
  return getCmsPath();
}


/** Master List Updated September, 2019 (LLSU2-157). Prefer helpers.MASTER_AUDIENCE_LIST_ID. */
export const MAILCHIMP_LISTID = '46eca3db3b';
export const PROJECTS_PER_PAGE = 12;
/**
 * Cap for "fetch all" list requests. Must stay <= CMS `rest.maxLimit`
 * (LivableStreetsCMS config/api.js). Strapi 5 treats pagination[limit]=-1 as 1,
 * so legacy unlimited (_limit 0 / -1) must map here instead.
 */
export const STRAPI_REST_MAX_LIMIT = 500;
/** Full project catalog page size; must stay <= CMS rest.maxLimit (LLSU2-176). */
export const PROJECT_CATALOG_LIMIT = STRAPI_REST_MAX_LIMIT;
/**
 * Shallow list populate — put these on the request so mergePopulateIntoParams
 * skips the heavy projectFeatures/documents graph used for detail pages.
 */
export const PROJECT_LIST_POPULATE = {
  'populate[thumbnail]': 'true',
  'populate[program]': 'true',
  'populate[projectTypes]': 'true',
  'populate[projectstatus]': 'true',
};
/** Autocomplete only needs title + slug — skip thumbnails and relations. */
export const PROJECT_SUGGEST_QUERY = {
  _limit: 5,
  populate: '',
  'fields[0]': 'title',
  'fields[1]': 'slug',
};
/** /search listing only needs title + slug. Collections with a program relation add populate separately. */
export const SEARCH_RESULT_QUERY = {
  populate: '',
  'fields[0]': 'title',
  'fields[1]': 'slug',
};
export const SEARCH_RESULT_PROGRAM_POPULATE = {
  'populate[program][fields][0]': 'title',
};
/**
 * Filter dropdown options only need id + title.
 * `populate: ''` short-circuits mergePopulateIntoParams so the heavy program
 * relation graph is not requested (was ~3MB on /projects).
 */
export const FILTER_OPTION_QUERY = {
  populate: '',
  'fields[0]': 'title',
  _limit: 100,
};
export const FILTER_OPTION_FIELDS = ['id', 'Title', 'CMS Name'];
export const STUB_DESCRIPTION_LENGTH = 150;
/** Project list cards: allow full opening sentence(s), not mid-sentence word chops. */
export const PROJECT_STUB_DESCRIPTION_LENGTH = 320;

export const BROWSER_TITLE_PREFIX = '';
export const BROWSER_TITLE_SUFFIX = ' | LADOT Livable Streets';
export const OG_SITE_NAME = 'LADOT Livable Streets';
/** Homepage-only document.title (LLSU2-137). Other routes keep buildTitle(). */
export const HOME_BROWSER_TITLE = 'LADOT Livable Streets — Safe, livable streets for Los Angeles';

/** Stable m-list-nav cmsName values in Strapi (must match Content Manager exactly). */
export const NAV_ABOUT = 'Header - Who We Are';
export const NAV_LIST_HEADER_WHO_WE_ARE = 'List - Header - Who We Are';
export const NAV_OUR_PROGRAMS = 'Header - Our Programs';
export const NAV_SAFETY_PROGRAMS = 'Header - What We Do, Safety Programs';
export const NAV_PUBLIC_SPACE_PROGRAMS = 'Header - What We Do - Public Space Programs';
export const NAV_OUR_PROJECTS = 'Header - Our Projects';
export const NAV_FEATURED_PROJECTS = 'Header - Our Projects - Featured Projects';
export const NAV_PROJECT_TYPES = 'Header - Our Projects - Project Types';
export const NAV_GET_INVOLVED = 'Header - Get Involved';
export const NAV_TAKE_ACTION = 'Header - Get Involved - Take Action';
export const NAV_WE_WANT_TO_HEAR = 'Header - Get Involved - We Want To Hear From You';
export const NAV_MAPS_AND_DATA = 'Header - Maps & Data';
export const NAV_OUR_PROJECTS_AND_DATA = 'Header - Maps & Data - List';
/** Hover-menu label for the full projects map (injected if missing from CMS). */
export const NAV_PROJECTS_MAP = 'Projects Map';
export const NAV_SEARCH = 'Header - Search';
export const NAV_RECOMMENDED_LINKS = 'Header - Search - Recommended Links';

/** Home hero carousel slide that includes the project search UI (Strapi cmsName). */
export const CAROUSEL_SLIDE_HERO_SEARCH = 'Home Hero - Slide 1 w/Search';
export const MLISTCARDS_TAKE_AN_ACTION = 'Take an Action';
export const PROGRAM_SLUG_ACTIVE_TRANSPORTATION = 'active-transportation';

export const FACEBOOK_URL = 'https://www.facebook.com/ladotofficial';
export const INSTAGRAM_URL = 'https://www.instagram.com/ladotofficial/';
export const TWITTER_URL = 'https://twitter.com/LADOTofficial';
export const YOUTUBE_URL = 'https://www.youtube.com/channel/UC90xEQsc5WdUuFg-I8j-cuQ';

//Normalization reference (keys we want, keys strapi has)
//export const nref = {
//  camelCaseTypeName: { - the name is js friendly
//    component<react component> - undefined or the react component
//    endpoint<string> - the endpoint string for accessing the data from strapi
//    isModule<bool> - is this a module content type?
//    fieldsUsed<string>[] - the strapi names for the fields we'll use in our code. This is used for building the component data in a clean object with camelCased properties
//  },
//  ...
//};
export const nref = {
  card: {
    component: undefined,
    endpoint: 'cards',
    isModule: false,
    fieldsUsed: [
      'Background',
      'CMS Name',
      'Description',
      'Display Mode',
      'id',
      'Link URL',
      'LinkMedia',
      'MGetInvolved',
      'Opens In New Tab',
      'SoftDelete',
      'Title',
    ],
  },
  carouselSlide: {
    component: CarouselSlide,
    endpoint: 'carousel-slides',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'id',
      'mCarousels',
      'SoftDelete',
    ],
  },
  category: {
    component: undefined,
    endpoint: 'categories',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'id',
      'SoftDelete',
      'Title',
    ],
  },
  council: {
    component: undefined,
    endpoint: 'councils',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'District Link URL', //todo: make url capitalization match
      'District Title',
      'id',
      'Location Link Url', //todo: make url capitalization match
      'Location Title',
      'SoftDelete',
    ],
  },
  contact: {
    component: undefined,
    endpoint: 'contacts',
    isModule: false,
    fieldsUsed: [
      'Address',
      'Description',
      'Email',
      'Events',
      'Feedback Form Link',
      'id',
      'Name',
      'Phone Number',
      'Programs',
      'SoftDelete',
    ],
  },
  event: {
    component: undefined,
    endpoint: 'events',
    isModule: false,
    fieldsUsed: [
      'Category',
      'CMS Name',
      'ContactInfo',
      'Contacts',
      'Content',
      'EventDate',
      'id',
      'Location Description',
      'Mailchimp Tag',
      'Program',
      'Slug',
      'SoftDelete',
      'Tags',
      'Timestamp',
      'Title',
    ],
  },
  getInvolvedCard: {
    component: undefined,
    endpoint: 'get-involved-cards',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'id',
      'Image',
      'mGetInvolveds',
      'navigationlink',
      'SoftDelete',
      'Title',
    ],
  },
  mapParent: {
    component: MapParent,
    endpoint: 'projects',
    isModule: false,
    fieldsUsed: [
      'Center ArcGIS ID',
      'CMS Name',
      'Contact Description',
      'Council',
      'Description',
      'id',
      'Location Description',
      'Phase',
      'PhotosAndVideos',
      'Program',
      'ProjectDocuments',
      'ProjectFeatures',
      'ProjectPartners',
      'ProjectTypes',
      'Slug',
      'SoftDelete',
      'Status',
      'Tags',
      'Thumbnail',
      'Title',
      'What Description',
      'Why Description',
      'Intro Description',
    ],
  },
  mBrandBar: {
    component: MBrandBar,
    endpoint: 'm-brand-bar',
    isSingleType: true,
    isModule: true,
    fieldsUsed: [
      'CMS Name',
      'id',
      'Logo Alt',
      'Logo',
      'SoftDelete',
    ],
  },
  mCarousel: {
    component: MCarousel,
    endpoint: 'm-carousel',
    isSingleType: true,
    isModule: true,
    fieldsUsed: [
      'BackgroundImage',
      'BackgroundVideo',
      'CarouselSlides',
      'CMS Name',
      'id',
      'SoftDelete',
    ],
  },
  mediaItem: {
    component: undefined,
    endpoint: 'media-items',
    isModule: false,
    fieldsUsed: [
      'Alt',
      'Caption',
      'id',
      'MediaEmbed',
      'MediaImage',
      'MediaVideo',
      'SoftDelete',
    ],
  },
  memorial: {
    component: undefined,
    endpoint: 'memorials',
    isModule: false,
    fieldsUsed: [
      'Address',
      'Age',
      'CaseId',
      'CMS Name',
      'Description',
      'EventDate',
      'Media',
      'Point_X',
      'Point_Y',
      'SoftDelete',
      'Title',
    ],
  },
  mFooter: {
    component: MFooter,
    endpoint: 'm-footer',
    isSingleType: true,
    isModule: true,
    fieldsUsed: [
      'Bot Left Text',
      'CMS Name',
      'Contact Text',
      'id',
      'Legal Text',
      'MobileContactLinks',
      'MobileLinks',
      'SocialList',
      'SoftDelete',
      'SubmenuA',
      'SubmenuB',
      'SubmenuC',
    ],
  },
  mGetInvolved: {
    component: MGetInvolved,
    endpoint: 'm-get-involved',
    isSingleType: true,
    isModule: true,
    fieldsUsed: [
      'Button Label',
      'Cards',
      'CMS Name',
      'Description',
      'id',
      'SoftDelete',
      'Title',
    ],
  },
  mHeader: {
    component: MHeader,
    endpoint: 'm-header',
    isSingleType: true,
    isModule: true,
    fieldsUsed: [
      'CMS Name',
      'id',
      'ImageBackground',
      'ImageLogo',
      'mListNavs',
      'Public Name',
      'SoftDelete',
      'Text Optional',
      'Title Optional',
      'Title',
    ],
  },
  mIntro: {
    component: MIntro,
    endpoint: 'm-intros',
    isModule: true,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'Display Mode',
      'id',
      'SoftDelete',
      'Title',
    ],
  },
  mLatestNews: {
    component: MLatestNews,
    endpoint: 'm-latest-news',
    isModule: true,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'id',
      'Program',
      'SoftDelete',
      'Title',
    ],
  },
  mListCards: {
    component: MListCards,
    endpoint: 'm-list-cards',
    isModule: true,
    fieldsUsed: [
      'BackgroundBlockColor',
      'Cards',
      'CMS Name',
      'id',
      'SoftDelete',
      'Title',
    ],
  },
  mListNav: {
    component: MListNav,
    endpoint: 'm-list-navs',
    isModule: true,
    fieldsUsed: [
      'CMS Name',
      'Description Optional',
      'Description',
      'Display Mode',
      'Display Position',
      'id',
      'ImageBackground',
      'ImageOptional',
      'mHeaders',
      'NavigationLinks',
      'ProjectTypes',
      'Public Name',
      'SoftDelete',
      'Title Short',
      'Title',
      'Url',
    ],
  },
  mProgramMapAd: {
    component: MProgramMapAd,
    endpoint: 'm-program-map-ads',
    isModule: true,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'id',
      'Program',
      'SoftDelete',
      'Title',
    ],
  },
  mProjectsCurrent: {
    component: MProjectsCurrent,
    endpoint: 'm-projects-current',
    isSingleType: true,
    isModule: true,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'id',
      'SoftDelete',
      'Title',
    ],
  },
  navigationLink: {
    component: undefined,
    endpoint: 'navigation-links',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'Document',
      'id',
      'ImageOptional',
      'OpensInNewTab',
      'Public Name',
      'SoftDelete',
      'Title',
      'Type',
      'Url',
    ],
  },
  news: {
    component: undefined,
    endpoint: 'news-items',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Content',
      'Description',
      'id',
      'Mailchimp Tag',
      'NewsDate',
      'Program',
      'RelatedProject',
      'Slug',
      'SoftDelete',
      'Tags',
      'Timestamp',
      'Title',
    ],
  },
  pageContent: {
    component: PageContent,
    endpoint: 'page-contents',
    isModule: false,
    fieldsUsed: [
      'Browser Title',
      'CMS Name',
      'Content',
      'id',
      'Slug',
      'SoftDelete',
    ],
  },
  pageContentDetail: {
    component: undefined,
    endpoint: 'page-content-details',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Contacts',
      'id',
      'Long Description',
      'Mailchimp Tag',
      'PhotosAndVideos',
      'Program',
      'Projects',
      'Short Description Small',
      'Short Description',
      'Slug',
      'SoftDelete',
      'Tags',
      'Title',
    ],
  },
  pageContentLanding: {
    component: PageContentLanding,
    endpoint: 'page-content-landings',
    isModule: false,
    fieldsUsed: [
      'Body',
      'BrandBar',
      'Browser Title',
      'CardList',
      'CMS Name',
      'Footer',
      'Header',
      'id',
      'NewsRelatedProgram',
      'NewsRelatedProject',
      'SoftDelete',
      'Subtitle',
      'Title',
    ],
  },
  pageEvents: {
    component: PageEvents,
    endpoint: 'page-event',
    isSingleType: true,
    isModule: false,
    fieldsUsed: [
      'CMSName',
      'Description',
      'EventsListing',
      'id',
      'SoftDelete',
      'Title',
    ],
  },
  pageEventDetails: {
    component: PageEventDetails,
    endpoint: 'pageeventdetails',
    isModule: false,
    fieldsUsed: [
      'CMSName',
      'EventDetailIntro',
      'EventDetails',
      'id',
      'SoftDelete',
      'Title',
    ],
  },
  pageGetInvolved: {
    component: PageGetInvolved,
    endpoint: 'page-get-involved',
    isSingleType: true,
    isModule: false,
    fieldsUsed: [
      'Body',
      'CardListA',
      'CardListB',
      'CardListC',
      'CMS Name',
      'Contact',
      'EventsRelatedProgram',
      'EventsRelatedProject',
      'EventsRelatedTag',
      'id',
      'Intro Subtitle',
      'Mailchimp Tag',
      'SoftDelete',
      'Title',
    ],
  },
  pageHome: {
    component: PageHome,
    endpoint: 'page-home',
    isSingleType: true,
    isModule: false,
    fieldsUsed: [
      'CMSName',
      'CurrentProjects',
      'GetInvolved',
      'HeroCarousel',
      'id',
      'SoftDelete',
      'SoftDelete',
    ],
  },
  pageNews: {
    component: PageNews,
    endpoint: 'page-news',
    isSingleType: true,
    isModule: false,
    fieldsUsed: [
      'CMSName',
      'id',
      'Description',
      'SoftDelete',
      'Title',
    ],
  },
  pageProjects: {
    component: PageProjects,
    endpoint: 'page-projects',
    isSingleType: true,
    isModule: false,
    fieldsUsed: [
      'CMSName',
      'id',
      'Description',
      'SoftDelete',
      'Title',
    ],
  },
  program: {
    component: undefined,
    endpoint: 'programs',
    isModule: false,
    fieldsUsed: [
      'ApplicationSteps',
      'CMS Name',
      'Color',
      'Contacts',
      'Events',
      'FeaturedProjects',
      'Get Involved Application Address',
      'Get Involved Email',
      'GetInvolvedContent',
      'GetInvolvedOnlineApplicationUrl',
      'GetInvolvedSubhead',
      'id',
      'Logo',
      'Long Description',
      'Mailchimp Tag',
      'Maps Intro Text',
      'MProgramMapAd',
      'PaperForms',
      'Project',
      'RelatedTag',
      'Short Description Small',
      'Short Description',
      'Slug',
      'SoftDelete',
      'Title',
    ],
  },
  programApplicationStep: {
    component: undefined,
    endpoint: 'program-application-steps',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'id',
      'SoftDelete',
      'Title',
    ],
  },
  projectFeatureLocation: {
    component: undefined,
    endpoint: 'project-feature-locations',
    isModule: false,
    fieldsUsed: [
      'id',
      'CMS Name',
      'ArcGIS ID',
      'ProjectFeatures',
      'Title',
    ],
  },
  projectFeature: {
    component: undefined,
    endpoint: 'project-features',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'id',
      'Image',
      'ProjectFeatureLocations',
      'Projects',
      'SoftDelete',
      'Title',
    ],
  },
  projectPartner: {
    component: undefined,
    endpoint: 'project-partners',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'id',
      'Link URL',
      'Projects',
      'SoftDelete',
      'Title',
    ],
  },
  project: {
    component: undefined,
    endpoint: 'projects',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Contact Description',
      'Contacts',
      'Council',
      'CouncilDistrictNames',
      'Custom Status Label',
      'Description',
      'FeaturedProgram',
      'FeedbackEmail',
      'id',
      'LastSave',
      'Location Description',
      'Mailchimp Tag',
      'NeighborhoodCouncilName',
      'PhotosAndVideos',
      'Program',
      'Project Id',
      'ProjectDocuments',
      'ProjectFeatures',
      'ProjectPartners',
      'projectstatus',
      'ProjectTypes',
      'Slug',
      'SoftDelete',
      'Status',
      'Tags',
      'Thumbnail',
      'Title',
      'What Description',
      'Why Description',
      'Intro Description',
    ],
  },
  projectStatus: {
    component: undefined,
    endpoint: 'project-statuses',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'id',
      'SoftDelete',
      'Title',
    ],
  },
  projectType: {
    component: undefined,
    endpoint: 'project-types',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Display Order',
      'Filter Value',
      'Icon',
      'IconHover',
      'id',
      'mListNavs',
      'Projects',
      'Public Name',
      'SoftDelete',
      'Text Optional',
      'Title',
      'Url',
    ],
  },
  tag: {
    component: Tag,
    endpoint: 'tags',
    isModule: false,
    fieldsUsed: [
      'CMS Name',
      'Description',
      'Events',
      'id',
      'News',
      'SoftDelete',
      'Title',
    ],
  },
};
export const nref_keys = Object.keys(nref);
export const nref_moduleNames = nref_keys.filter(key => {
  return nref[key].isModule;
});

/** Strapi 5 populate hint per nref key (from migration tooling). */
export function getPopulateSpecForNrefKey(nrefKey) {
  return strapi5Populate[nrefKey] || null;
}

/** Merge populate hints when multiple nref keys share one endpoint (e.g. mapParent + project → projects). */
export function getPopulateSpecForEndpoint(endpoint) {
  const matchingKeys = nref_keys.filter((key) => nref[key].endpoint === endpoint);
  if (!matchingKeys.length) return null;
  if (matchingKeys.length === 1) {
    return strapi5Populate[matchingKeys[0]] || null;
  }

  const mergedPopulate = {};
  for (const key of matchingKeys) {
    const inner = strapi5Populate[key]?.populate?.populate;
    if (inner && typeof inner === 'object') {
      Object.assign(mergedPopulate, inner);
    }
  }

  return Object.keys(mergedPopulate).length
    ? { populate: { populate: mergedPopulate } }
    : null;
}

export const imgPath = (src) => {
  if (src == null || src === '') return '';
  const s =
    typeof src === 'string'
      ? src.trim()
      : String((src && typeof src === 'object' && src.url != null ? src.url : src) || '').trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s)) return s;
  const path = s.startsWith('/') ? s : `/${s}`;
  const base = (path.startsWith('/uploads/') ? getCmsUploadBase() : getCmsPath()).replace(/\/+$/, '');
  return `${base}${path}`;
};
export const buildTitle = title => {
  return title && title.length > 0 ? `${BROWSER_TITLE_PREFIX}${title}${BROWSER_TITLE_SUFFIX}` : OG_SITE_NAME;
};
export const pageTitleWithoutSiteSuffix = (title = '') => {
  const i = title.indexOf(BROWSER_TITLE_SUFFIX);
  return i === -1 ? title : title.slice(0, i);
};

